const SEPARATOR = "/";

const cache = {};

export const sortFilters = (filterUrl, options) => {
  // Regex to remove trailing, leading and double slashes
  const filters = filterUrl
    .replace(/^\/+|\/+$/g, '')
    .replace(/\/{2,}/g, '/')
    .split(SEPARATOR);
  if (filters.length > 0) {
    const filterFullInfo = filters
      .map((f) => {
        const propPair = f.split("-");
        const propName = propPair[0];
        const propValue = propPair.slice(1).join("-");
        if (options[propName]) {
          const selectedVariant = options[propName].variants.find(
            (v) => (v.slug ?? v.option_value_slug) === propValue
          );
          let id;
          if (selectedVariant) {
            id = selectedVariant.id;
            cache[f] = id;
          } else {
            id = cache[f];
          }
          return {
            code: f,
            sort: id !== undefined ? Number(`${options[propName].sort_in_url}${id}`) : 0,
          };
        }
        return {
          code: f,
          sort: 0,
        };
      })
      .filter((f) => f);
    const sortedFilter = filterFullInfo
      .sort((a, b) => a.sort - b.sort)
      .map((f) => f.code);
    const finalFilter = sortedFilter.join(SEPARATOR);
    return filterUrl ? `${finalFilter}/` : finalFilter;
  }
  return filterUrl;
};
